const VideoAutoplay = ({ src }) => {
    if (!src) return null;

    return (
        <div className="video-player">
            <video
                className="video-player__media"
                src={src}
                playsInline
                autoPlay
                loop
                muted
            />
        </div>
    );
};

export default VideoAutoplay;
